import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "snippets",
  courseId: "writing-and-editing",
  order: 4,
  title: "Snippets",
  summary:
    "Text you type on every report (Miranda, consent language, disposition blocks) lives in Snippets and drops into the narrative with one click.",
  learn: [
    "Insert a department or personal snippet at the cursor, top, or end",
    "Create a snippet with placeholders",
    "Know the difference between Department Snippets and My Snippets",
  ],
  minutes: 3,
  sceneId: "snippets",
  tourId: "snippets",
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "The **Snippets** tab has two lists. Department Snippets are managed by your agency admin. My Snippets are yours. Both insert the same way.",
    },
    { type: "heading", text: "Insert a snippet" },
    {
      type: "steps",
      items: [
        "Open the **Snippets** tab in the right panel.",
        "Find the snippet and choose **Add to cursor**, **Add to top of report**, or **Add to end of report**.",
      ],
    },
    { type: "heading", text: "Create your own" },
    {
      type: "steps",
      items: [
        "In the **Snippets** tab, click **Add Snippet**.",
        "Fill in the Title and the Content.",
        "In the Content, write {{Name}} style placeholders for anything that changes per report.",
        "Click **Add** to save the snippet.",
      ],
    },
    {
      type: "paragraph",
      text: "After you insert a snippet that has placeholders, click each one in the narrative and fill it in.",
    },
    {
      type: "callout",
      tone: "note",
      text: "Department Snippets are read-only for officers. Ask your admin to add or change one from the **Snippets** tab of the agency dashboard.",
    },
    {
      type: "callout",
      tone: "tip",
      text: "If you insert the same snippet at the end of every report, put that text in a report template footer instead. The AI then includes it in the draft automatically.",
    },
  ],
  related: ["report-templates", "department-preferences-templates-checklists"],
};

export default lesson;
